export default "__VITE_ASSET__u_PpAzSp__"